import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchAddBankWallet } from "../../pages/FetchAddWallet";
import SWIFT from "../../assets/images/SWIFT-logo-add-wallet.png";
import SEPA from "../../assets/images/SEPA-logo-add-wallet.png";
import USD from "../../assets/images/USD-logo-add-wallet.svg";
import EUR from "../../assets/images/EUR-logo-add-wallet.svg";
import Input from "../common/Input";
import { useState } from "react";
import { addedBankWallet } from "../../store/actions/bankWalletsAction";
import DropdownInput from "../common/DropdownInput";

function AddBankWalletForm({ closePopup }) {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.user);
  const { t } = useTranslation();
  const [bank_name, setBank_name] = useState("");
  const [iban, setIban] = useState("");
  const [code, setcode] = useState("");
  const [street, setStreet] = useState("");
  const [city, setCity] = useState("");
  const [postCode, setPostCode] = useState("");
  const [country, setCountry] = useState("");
  const [type, setType] = useState("swift");
  const [curr, setCurr] = useState("usd");

  const reciever = userInfo.fname + " " + userInfo.lname;

  const handleMethodChange = (event) => {
    setType(event.target.value);
    if (event.target.value === "sepa") {
      setCurr("eur");
    }
  };

  const handleBankNameChange = (e) => {
    setBank_name(e.target.value);
  };
  const handleCurrChange = (event) => {
    setCurr(event.target.value);
  };

  const handleNameChange = (e) => {

  };

  const handleCityChange = (e) => {
    setCity(e.target.value);
  };

  const handleStreetChange = (e) => {
    setStreet(e.target.value);
  };

  const handlePostCodeChange = (e) => {
    setPostCode(e.target.value);
  };

  const handleIbanChange = (e) => {
    setIban(e.target.value);
  };

  const handlecodeChange = (e) => {
    setcode(e.target.value);
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    fetchAddBankWallet({ type, bank_name, curr, iban, code, owner: reciever, country, address: street, city, zip_code: postCode }).then(
      (data) => {
        addedBankWallet(dispatch, data);
        closePopup();
      }
    );
  };

  return (
    <form onSubmit={handleSubmit} className="wallet__add">
      <button onClick={() => closePopup()} className="close-popup">
        <i className="ri-close-line"></i>
      </button>
      <h3>{t("Add Bank Account")}</h3>
      <div className="radio-secect">
        <p className="label">{t("Method")}</p>
        <div className={`option ${type === "swift" ? "selected" : ""}`}>
          <label>
            <input
              type="radio"
              value="swift"
              checked={type === "swift"}
              onChange={handleMethodChange}
              className="radio-custom"
            />
            <div className="radio-new">
              <i className="ri-check-line"></i>
            </div>{" "}
            <img src={SWIFT} alt="" />
          </label>
        </div>
        <div className={`option ${type === "sepa" ? "selected" : ""}`}>
          <label>
            <input
              type="radio"
              value="sepa"
              checked={type === "sepa"}
              onChange={handleMethodChange}
              className="radio-custom"
            />
            <div className="radio-new">
              <i className="ri-check-line"></i>
            </div>
            <img src={SEPA} alt="" />
          </label>
        </div>
      </div>
      <div className="radio-secect">
        <p className="label">{t("Currency")}</p>
        <div
          className={`option ${curr === "usd" ? "selected" : ""}`}
          style={type === "sepa" ? { display: "none" } : {}}
        >
          <label>
            <input
              type="radio"
              value="usd"
              checked={curr === "usd"}
              onChange={handleCurrChange}
              className="radio-custom"
            />
            <div className="radio-new">
              <i className="ri-check-line"></i>
            </div>{" "}
            <img className="curr" src={USD} alt="" /> USD
          </label>
        </div>
        <div
          className={`option ${curr === "eur" ? "selected" : ""} ${type === "sepa" ? "only" : ""
            }`}
        >
          <label>
            <input
              type="radio"
              value="eur"
              checked={curr === "eur"}
              onChange={handleCurrChange}
              className="radio-custom"
            />
            <div className="radio-new">
              <i className="ri-check-line"></i>
            </div>
            <img className="curr" src={EUR} alt="" /> EUR
          </label>
        </div>
      </div>
      <Input
        id="iban"
        label={t("IBAN")}
        value={iban}
        onChange={handleIbanChange}
        placeholder={t("ex. GB29NWBK60161331926819")}
        pattern="[A-Z]{2}[0-9]{2}[A-Z0-9]{10,30}"
        required
      />
      <Input
        id="code"
        label={t("SWIFT/BIC")}
        value={code}
        onChange={handlecodeChange}
        placeholder={t("ex. UNSTGKLJUUU")}
        pattern=".*"
        required
      />
      <Input
        id="bank_name"
        label={t("Bank Name")}
        value={bank_name}
        onChange={handleBankNameChange}
        placeholder={t("Enter Bank Name")}
        required
      />
      <Input
        id="reciever"
        label={t("Receiver")}
        value={reciever}
        onChange={handleNameChange}
        placeholder={t("Enter receiver")}
        required
        disabled={true}
      />
      <DropdownInput
        id="country"
        label={t("Country")}
        value={country}
        setValue={setCountry}
        placeholder={t("Enter Country")}
        required
        options={["Aland Islands",
          "Andorra",
          "Austria",
          "Azores",
          "Belgium",
          "Canary Islands",
          "Cyprus",
          "Estonia",
          "Finland",
          "France",
          "Germany",
          "Gibraltar",
          "Greece",
          "Ireland",
          "Italy",
          "Latvia",
          "Lithuania",
          "Luxembourg",
          "Madeira",
          "Malta",
          "Monaco",
          "Netherlands",
          "Portugal",
          "San Marino",
          "Slovakia",
          "Slovenia",
          "Spain",
          "Bulgaria",
          "Croatia",
          "Czech Republic",
          "Denmark",
          "Gibraltar",
          "Hungary",
          "Iceland",
          "Liechtenstein",
          "Norway",
          "Poland",
          "Romania",
          "Sweden",
          "Switzerland",
          "United Kingdom"]}
      />
      <Input
        id="city"
        label={t("City")}
        value={city}
        onChange={handleCityChange}
        placeholder={t("Enter City")}
        pattern=".*"
        required
      />
      <Input
        id="street"
        label={t("Street")}
        value={street}
        onChange={handleStreetChange}
        placeholder={t("Enter Address")}
        pattern=".*"
        required
      />
      <Input
        id="postCode"
        label={t("Postal Code")}
        value={postCode}
        onChange={handlePostCodeChange}
        placeholder={t("Enter Postal Code")}
        pattern=".*"
        required
      />
      <button className="form-default__submit" type="submit">
        {t("Save")}
      </button>
      <button onClick={() => closePopup()} className="form-default__cancel only-mobile">
        {t("Cancel")}
      </button>
    </form>
  );
}

export default AddBankWalletForm;
